import { AbstractControl } from "@angular/forms";

export function formControlNully(control: AbstractControl): boolean {
  const value = control.value;

  if (value === "" || value === null || value === undefined) {
    return true;
  }

  return false;
}
